/**
 * Created by DejanK on 3/23/2017.
 */
import angular from 'angular'

import BidManagerUI from './ui/rfp.bid-manager.main.ui.module'


import Dialogs from './dialogs'
import BidManagerRedirectService from './bid-manager-redirect.service'
import BidManagerListViewService from './core/bid-manager-list.view.service'
import BidManagerService from './core/bid-manager.service'
import BidManagerRepository from './core/bid-manager.repo'
import BidManagerBulkBidActionsService from './core/actions/bulk-bid-actions.service'
import BidManagerSingleBidActionsService from './core/actions/single-bid-actions.service'
import BidManagerActionsFactory from './core/actions/bid-manager-actions.factory'
import BidManagerBidActionsService from './core/actions/bid-manager-bid-actions.service';

export default angular.module('rb.rfp.bidManager.main', [ BidManagerUI.name ])
  .config(Dialogs)

  .service('BidManagerRedirectService', BidManagerRedirectService)

  .service('BidManagerService', BidManagerService)
  .service('BidManagerRepository', BidManagerRepository)
  .service('BidManagerListViewService', BidManagerListViewService)

  .service('BidManagerBidActionsService', BidManagerBidActionsService)
  .factory('BidManagerActionsFactory', BidManagerActionsFactory)
  .service('BidManagerBulkBidActionsService', BidManagerBulkBidActionsService)
  .service('BidManagerSingleBidActionsService', BidManagerSingleBidActionsService)
